<template>
    <!-- Footer -->
    <footer class="mt-20 bg-gray-900 sm:mt-40">
        <div class="mx-auto max-w-7xl px-6 py-8 lg:px-8">
            <div class="lg:flex lg:items-center lg:justify-between">
                <div>
                    <h3 class="text-sm/6 font-semibold text-white">Subscribe to our newsletter</h3>
                    <p class="mt-2 text-sm/6 text-gray-300">The latest news, articles, and resources, sent to your inbox weekly.</p>
                </div>
                <form class="mt-6 sm:flex sm:max-w-md lg:mt-0">
                    <label for="email-address" class="sr-only">Email address</label>
                    <input type="email" name="email-address" id="email-address" autocomplete="email" required="" class="w-full min-w-0 rounded-md bg-white/5 px-3 py-1.5 text-base text-white outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-500 sm:w-56 sm:text-sm/6" placeholder="Enter your email" />
                    <div class="mt-4 sm:mt-0 sm:ml-4 sm:shrink-0">
                        <button type="submit" class="flex w-full items-center justify-center rounded-md bg-indigo-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500">Subscribe</button>
                    </div>
                </form>
            </div>
            <div class="mt-8 border-t border-white/10 pt-8 md:flex md:items-center md:justify-between">
                <div class="flex gap-x-6 md:order-2">
                    <a v-for="item in footerNavigation.legal" :key="item.name" :href="item.href" class="text-gray-400 hover:text-gray-300 text-sm">
                        <span class="">{{ item.name }}</span>
                    </a>
                </div>
                <p class="mt-2 text-sm/6 text-gray-400 md:order-1 md:mt-0">&copy; 2025 Inventree, Inc. All rights reserved.</p>
            </div>
        </div>
    </footer>
</template>

<script setup>

const footerNavigation = {
    legal: [
        { name: 'Terms of service', href: '#' },
        { name: 'Privacy policy', href: '#' },
    ],
}

</script>

<style scoped>

</style>